export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7374.67fa9e85.jpg";